/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_IdInputs */



/**
* | output |
* | --- |
* | "Event Id" |
*
* @param {Event_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_id = /** @type {((inputs?: Event_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID de l’événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignis-ID")
	if (locale === "it") return /** @type {LocalizedString} */ ("ID evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Идентификатор события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Id. de evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件 ID")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントID")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट आईडी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("ID do evento")
	return /** @type {LocalizedString} */ ("Event Id")
});